import React from "react";
import { Tooltip } from "react-bootstrap";
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  Legend,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";

const domain = [0, 1];
const ticks = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

const data = [
  { name: "Year 05", value: 46 },
  { name: "Year 04", value: 40 },
  { name: "Year 03", value: 38 },
  { name: "Year 02", value: 36 },
  { name: "Year 01", value: 33 },
];

const CustomLabel = (props) => {
  const { x, y, width, height, value } = props;

  const fireOffset = value.toString().length < 5;
  const offset = fireOffset ? -40 : 5;
  return (
    <text
      x={x + width - offset}
      y={y + height - 5}
      fill={fireOffset ? "#3E3E3E" : "#fff"}
      textAnchor="end"
      fontWeight={600}
    >
      {value} %
    </text>
  );
};

const NetProfitChart = () => {
  return (
    <>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart width={730} height={250} data={data} layout="vertical">
          <CartesianGrid opacity={0.5} horizontal={false} />
          <XAxis
            type="number"
            domain={domain}
            ticks={ticks}
            tickCount={10}
            // tickFormatter={toPercent}
            hide
          />
          <YAxis
            type="category"
            tick={{ fill: "#3E3E3E", fontWeight: 600 }}
            dataKey="name"
            width={100}
            tickLine={false}
          />
          <Tooltip />

          <Bar
            dataKey="value"
            fill="#e11f1c"
            barSize={22}
            background={{ fill: "#D9D9D9" }}
          >
            <LabelList dataKey="value" content={CustomLabel} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </>
  );
};

export default NetProfitChart;
